import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [hasMemberRole, setHasMemberRole] = useState(null);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is authenticated, check their role
        try {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const userData = userSnap.data();
            const role = userData.role;

            if (role === 'admin') {
              setHasMemberRole(true);
            } else {
              setHasMemberRole(false);
            }
          } else {
            // No user document found
            setHasMemberRole(false);
          }
        } catch (error) {
          console.error('Error fetching user role:', error);
          setHasMemberRole(false);
        }
        setIsAuthenticated(true);
      } else {
        // User is not authenticated
        setIsAuthenticated(false);
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [auth, db]);

  // While checking auth and role, render nothing or a loading state
  if (isAuthenticated === null || hasMemberRole === null) {
    return null; // Optionally, you can return a loading spinner here
  }

  // If user is authenticated and has member role, render the children (dashboard)
  if (isAuthenticated && hasMemberRole) {
    return children;
  }

  // Otherwise, redirect to the member login page
  return <Navigate to="/admin-login" replace />;
};

export default ProtectedRoute;